import { Navigate, generatePath } from 'react-router-dom';

import { NBA_SCOUTING_CENTER_SCORES } from '@sorare/core/src/constants/__generated__/routes';

const NBAScoreGamePage = () => {
  return <Navigate to={generatePath(NBA_SCOUTING_CENTER_SCORES)} />;
};

export default NBAScoreGamePage;
